var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"plus-poker",class:{collapsed: _vm.collapsed},on:{"click":_vm.handleUncollapse}},[_vm._v("\n  +\n")])}
var staticRenderFns = []

export { render, staticRenderFns }